import React, { FC, useRef } from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';
import { Text } from '@wix/wix-ui-tpa/cssVars';
import settingsParams from '../../../../../settingsParams';
import { st, classes } from './ServiceDescription.st.css';
import { Collapsible } from './Collapsible/Collapsible';

export type ServiceDescriptionProps = {
  description: string;
};

export const ServiceDescription: FC<ServiceDescriptionProps> = ({
  description,
}) => {
  const { isMobile } = useEnvironment();
  const settings = useSettings();
  const tagName = settings.get(settingsParams.serviceDescriptionFontHtmlTag);
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div tabIndex={-1} className={st(classes.root, { isMobile })}>
      <Collapsible
        className={classes.collapsible}
        showMoreLabel={settings.get(settingsParams.showMoreDescriptionText)}
        showLessLabel={settings.get(settingsParams.showLessDescriptionText)}
        contentRef={contentRef}
      >
        <div ref={contentRef}>
          <Text
            className={classes.text}
            tagName={tagName}
            data-hook="service-description-text"
          >
            {description}
          </Text>
        </div>
      </Collapsible>
    </div>
  );
};
